import { useMutation } from "@tanstack/react-query";
import { useExonnApi } from "src/exonn-api/exonn-api.tsx";
import { useSnackbar } from "src/notifications/SnackbarProvider.ts";
import { useResourceFormApi } from "src/components/Form/hooks/useResourceFormApi.ts";
import { useResourceFormTranslation } from "src/components/Form/hooks/useResourceFormTranslation.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { serverErrorMessage } from "src/admin/modules/supplier-order/forms/supplier-order/hooks/useServerErrorMessage.ts";

type Request = {
  method?: "post" | "put" | "delete";
  url: string;
  body?: unknown;
};

/**
 * Действие над заказом (смена статуса, позиции, приход): после успеха форма перечитывается
 * с сервера, при ошибке показывается сообщение бэкенда.
 */
export const useSupplierOrderAction = (orderId: string | undefined) => {
  const { t } = useResourceFormTranslation();
  const exonnApi = useExonnApi();
  const snackbar = useSnackbar();
  const formApi = useResourceFormApi();

  return useMutation({
    mutationKey: [ResourceEnum.SupplierOrder, orderId, "action"],
    mutationFn: ({ method = "post", url, body }: Request) =>
      method === "delete"
        ? exonnApi.client.delete(url)
        : exonnApi.client[method](url, body),
    onSuccess: () => {
      formApi.refresh({ revalidateData: true, resetForm: true });
    },
    onError: (error) => {
      snackbar.error({
        flash: true,
        message: serverErrorMessage(error, t("notifications.action-failed")),
      });
    },
  });
};
